export default __webpack_public_path__ + "static/media/dashboard_inactive.b7bea41a.svg";